/**
 * A4 — Adaptateur d'API du bureau pour les composants partagés avec le terrain
 * (PlanAnnote.jsx, EpinglePlan.jsx) : même interface que terrain/src/api/client.js
 * (chemins sans le préfixe /api, session par cookie).
 */
const API_URL = process.env.REACT_APP_BACKEND_URL || '';

async function requete(method, path, body = null) {
  const opts = { method, credentials: 'include', headers: {} };
  if (body instanceof FormData) opts.body = body;
  else if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
  const res = await fetch(`${API_URL}/api${path}`, opts);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    let msg = err.detail;
    if (Array.isArray(msg)) msg = msg.map((e) => (typeof e === 'string' ? e : e.msg)).join(' · ');
    else if (msg && typeof msg === 'object') msg = msg.msg || msg.message || JSON.stringify(msg);
    throw new Error(msg || 'Erreur serveur');
  }
  return res.json();
}

async function getBlob(path) {
  const res = await fetch(`${API_URL}/api${path}`, { credentials: 'include' });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    throw new Error((typeof err.detail === 'string' && err.detail) || 'Fichier indisponible');
  }
  return res.blob();
}

const api = {
  get: (p) => requete('GET', p),
  post: (p, b) => requete('POST', p, b),
  put: (p, b) => requete('PUT', p, b),
  del: (p) => requete('DELETE', p),
  delete: (p) => requete('DELETE', p),
  getBlob,
};

export default api;
